<template>
  <router-view
    v-if="state"
    v-slot="{ Component }"
  >
    <div class="h-full min-h-full">
      <component :is="Component" />
    </div>
  </router-view>
</template>

<script lang="ts" setup>
import {
  onBeforeMount, provide, Ref, ref,
} from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { Pages } from '@/router';
import { analytics, marketing } from '@/services/tracking';
import { getAppState, AppState } from './api/get_app_state';

const route = useRoute();
const router = useRouter();

const state: Ref<AppState | undefined> = ref();
provide('state', state);

onBeforeMount(async () => {
  try {
    const appState = await getAppState();
    state.value = appState;
    analytics.identify(appState.user.id);
    marketing.identify(appState.user.id, {
      email: appState.user.email,
      firstName: appState.user.firstName,
      lastName: appState.user.lastName,
      createdAt: appState.user.createdAt,
    });

    if (appState.projects.length === 0) {
      router.replace({ name: Pages.welcomeVideo });
    }

    if (route.name === Pages.app) {
      if (route.params.projectId) {
        router.replace({ name: Pages.dashboardHome, params: { projectId: route.params.projectId } });
      } else if (appState.projects.length === 1) {
        const projectId = appState.projects[0].id;
        router.replace({ name: Pages.dashboardHome, params: { projectId } });
      } else {
        router.replace({ name: Pages.projectSelect });
      }
    }
  } catch (error) {
    console.error('error in app/index.vue onBeforeMount', error);
    router.replace({ name: Pages.crash });
  }
});
</script>
